import ServerAppMenuOrderV2 from './ServerAppMenuOrderV2';

export default ServerAppMenuOrderV2;
